import React, { useCallback, useEffect, useState } from "react";
import Layout from "./layout/Layout";
import { format } from "date-fns";
import { numberFormatter } from "utils/number.util";
import { getLeaderboard } from "services/quiz";
import Spinner from "react-bootstrap/esm/Spinner";

const Leaderboard = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [leaderboard, setLeaderboard] = useState([]);

    function parseMonth() {
        return format(new Date(), "yyyy-MM");
    }

    const getLeaderboardData = useCallback(async () => {
        try {
            setIsLoading(true);

            const leaderboardData = await getLeaderboard();

            setLeaderboard(leaderboardData.data);
        } catch (e) {
            console.log(e.message);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        getLeaderboardData();
    }, [getLeaderboardData]);

    if (isLoading) {
        return (
            <Layout>
                <div style={{ padding: "10px" }}>
                    <Spinner animation="border" role="status" variant="primary">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>
            </Layout>
        );
    }

    return (
        <>
            <Layout>
                <div style={{ padding: "10px" }}>
                    <button
                        type="button"
                        className="btn btn-primary waves-light"
                        onClick={getLeaderboardData}
                    >
                        Refresh
                    </button>
                </div>
                <div className="rows">
                    <div className="containers table-responsive">
                        {/* <!--Table--> */}
                        <table
                            className="display nowrap ns z-depth-1 table table-striped table-bordered row-border order-column table-hover"
                            style={{ width: "100%" }}
                        >
                            <thead>
                                <tr>
                                    <th className="black-text text-darken-2">Month</th>
                                    <th className="black-text text-darken-2">Name</th>
                                    <th className="black-text text-darken-2">ISE2</th>
                                    <th className="black-text text-darken-2">MSISDN</th>
                                    <th className="black-text text-darken-2">Total Points</th>
                                </tr>
                            </thead>
                            <tbody>
                                {leaderboard.map((record) => (
                                    <tr key={record.id}>
                                        <td className="ns" style={{ textAlign: "center" }}>
                                            {parseMonth()}
                                        </td>
                                        <td className="ns" style={{ textAlign: "center" }}>
                                            {record.name}
                                        </td>
                                        <td className="ns" style={{ textAlign: "center" }}>
                                            {record.ise2code}
                                        </td>
                                        <td className="ns" style={{ textAlign: "center" }}>
                                            {record.mobileNumber}
                                        </td>
                                        <td className="ns" style={{ textAlign: "center" }}>
                                            {numberFormatter.format(record.totalPoints)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan={14}>
                                        Showing {leaderboard.length} of {leaderboard.length}{" "}
                                        record(s)
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default Leaderboard;
